/** Mirrors backend `appendPayoutQueueTabFilter('open')` — floor actions only on open queue payouts. */

const PAYOUT_NON_OPEN_COMPLIANCE = new Set([
  'COMPLIANT',
  'INVESTIGATING',
  'SMR_DRAFT',
  'SMR_FILED',
])

const ACTIVE_INVESTIGATION_CASE_STATUSES = new Set([
  'OPEN',
  'INVESTIGATING',
  'PENDING_EVIDENCE',
  'ESCALATED',
  'PENDING_REVIEW',
  'PENDING_APPROVAL',
  'SUSPICION_FORMED',
])

/**
 * True when Dismiss / Start Investigation / Start ECDD are appropriate (open queue only).
 * Linked investigation, SMR, or closed/compliant payouts are handled in Compliance Safe.
 */
export function payoutMonitoringActionsAllowed(payout) {
  if (!payout) return false
  const cs = String(payout.complianceStatus || '').toUpperCase()
  if (PAYOUT_NON_OPEN_COMPLIANCE.has(cs)) return false
  if (payout.hasSmrCase) return false

  const linked = payout.linkedCase
  if (linked) {
    const st = String(linked.status || '').toUpperCase()
    const type = String(linked.caseType || linked.case_type || '').toUpperCase()
    if (ACTIVE_INVESTIGATION_CASE_STATUSES.has(st)) return false
    if (st === 'SMR_DRAFT' || st === 'FILED') return false
    if (type === 'SMR') return false
  }

  return true
}
